export default __webpack_public_path__ + "static/media/bacground.9c7a6ad4.jpg";